import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box, IconButton, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import { apiOperation, headers } from "../../services/api";
import { Close, Visibility } from "@mui/icons-material";
import { OrderDetails } from "../OrderDetails";
import styled from 'styled-components';
import { ETipoStatusPedido } from "../../models/enums/TipoStatusPedido";
import { Pedido } from "../../models/notouch/pedido";
import { Paginacao, Resultado } from "../../models/base/basic";


export const HeaderModal = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const ContentModal = styled.div`
	padding: 15px;
	width: 55vw;
	margin-left: 25%;
  margin-top: 5%;
	background: var(--surface-raised);
	box-shadow: 24px;
	border-radius: 10px;
`;

export const SubTitle = styled.span`
	line-height: 24px;
	letter-spacing: 0.5px;
	color: var(--text-primary);
	display: inline-block;
	margin-bottom: 20px;
  font-size: 24px; 
  font-weight: 600; 
  width: 100%; 
  text-align: center; 
`;



export const Order = ({ showLoading, hideLoading, showError }: any) => {
  const navigate = useNavigate();
  const [orderList, setOrderList] = useState<Pedido[]>([]);
  const [selectedOrder, setSelectedOrder] = useState<Pedido>();
  const [showDetails, setshowDetails] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    paginaCorrente: 0,
    quantidadePaginas: 0,
    tamanhoPagina: 10,
    quantidadeRegistros: 0,
  });
  
  // INICIO PAGINAÇÃO
  const handleChangeRowsPerPage = (event: any) => {
    setRecordsPerPage(event.target.value);
    setPagination({
      ...pagination,
      paginaCorrente: 0,
      tamanhoPagina: event.target.value | 10,
    });
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPagination({
      ...pagination,
      paginaCorrente: newPage,
    });
  };
  // FIM PAGINAÇÃO

  const getOrdersHistory = async (params = "") => {
    showLoading("Carregando compras...");
    try {
      const config = {
        headers: headers(),
      };
      let urlString = `notouch/pedido/listar?pagina=${pagination.paginaCorrente + 1}&registrosPagina=${pagination.tamanhoPagina}`;

      urlString += params;

      const { data } = await apiOperation.get<Resultado<Paginacao<Pedido>>>(urlString, config);

      if (!data.erro) {
        setOrderList([...data.valor.dados]);
        setPagination({
          ...pagination,
          quantidadePaginas: data.valor.quantidadePaginas,
          quantidadeRegistros: data.valor.quantidadeRegistros,
        });
        hideLoading();
      } else {
        throw new Error(`${data.erros?.join("|")}`);
      }
    } catch (error: any) {
      showError(
        "Erro ao carregar pedidos",
        `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`
      );
      hideLoading();
    }
  };

  const formatStatusPedido = (value: any) => {
      var status = ETipoStatusPedido[value as keyof typeof ETipoStatusPedido];
      var css = {
        backgroundColor: "var(--surface-sunken)",
        borderRadius: "15px",
        width: "fit-content",
        padding: "inherit",
        color: "var(--text-primary)",
        margin: "auto",
      };
  
      switch (status) {
        case ETipoStatusPedido.CONFIRMADO:
        case ETipoStatusPedido.FINALIZADO:
          return { ...css, backgroundColor: "var(--success-surface)", color: "var(--text-primary)" };
        case ETipoStatusPedido.CANCELADO:
          return { ...css, backgroundColor: "var(--error-surface)", color: "var(--text-primary)" };
        case ETipoStatusPedido.CRIADO:
          return { ...css, backgroundColor: "var(--warning-surface)", color: "var(--text-primary)" };
        default:
          return { ...css };
      }
    }

  useEffect(() => {
    getOrdersHistory();
  }, [pagination.paginaCorrente, pagination.tamanhoPagina]);

  return (
    <>
      <Box sx={{paddingBlockEnd: 3, textAlign: "center", fontSize: "20px", color: "var(--text-secondary)"}}>
          <h3>Minhas Compras</h3>
      </Box>
      <TableContainer>
        <Table
          sx={{ minWidth: 650 }}
          size="small"
        >
          <TableHead>
            <TableRow sx={{borderBlockStart: "1px solid var(--border-default)"}}>
              
              <TableCell sx={{textAlign: "left", fontSize: "16px", paddingTop: "20px"}}>Número</TableCell>
              <TableCell sx={{textAlign: "left", fontSize: "16px", paddingTop: "20px"}}>Descrição</TableCell>
              <TableCell sx={{textAlign: "center", fontSize: "16px", paddingTop: "20px"}}>Data Compra</TableCell>
              <TableCell sx={{textAlign: "center", fontSize: "16px", paddingTop: "20px"}}>Valor</TableCell>
              <TableCell sx={{textAlign: "center", fontSize: "16px", paddingTop: "20px"}}>Status</TableCell>
              <TableCell sx={{textAlign: "center", fontSize: "16px", paddingTop: "20px"}}>Detalhes</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {orderList.map((item) => (
              <TableRow
              key={item.id}
              sx={{"&:last-child td, &:last-child th": { border: 0 },}}
              hover
              >
                <TableCell align="left"> {item.pedidoNumero} </TableCell>

                <TableCell align="left"> {item.produtoNome} </TableCell>

                <TableCell align="center"> {moment(item.dataInclusao).format("DD/MM/YYYY HH:mm")} </TableCell>

                <TableCell align="center"> {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.produtoPreco ?? 0)} </TableCell>

                <TableCell align="center" style={{ whiteSpace: "break-spaces" }}>
                  <div style={formatStatusPedido(item.pedidoStatus)} >
                      {ETipoStatusPedido[item.pedidoStatus as keyof typeof ETipoStatusPedido] ?? "N/D"}
                  </div>
                </TableCell>

                <TableCell align="center">
                  <IconButton
                    onClick={() => {
                      setshowDetails(true)
                      setSelectedOrder(item);
                    }}
                    color="primary"
                    aria-label="Detalhes"
                  >
                    <Visibility />
                  </IconButton>
                </TableCell>
        
              </TableRow>
            ))}
            {orderList.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  Nenhum registro encontrado
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={pagination.quantidadeRegistros}
          page={pagination.paginaCorrente}
          onPageChange={handleChangePage}
          rowsPerPage={recordsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={"Registros por página: "}
        />
      </TableContainer>
      <Modal
        open={showDetails}
        onClose={() => setshowDetails(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ContentModal>
          <HeaderModal>
            <SubTitle style={{color: "var(--text-primary)"}}>Detalhes da Compra</SubTitle>
            <IconButton onClick={() => setshowDetails(false)}>
              <Close />
            </IconButton>
          </HeaderModal>
          <Box>
            <OrderDetails selectedOrder={selectedOrder}/>
          </Box>
        </ContentModal>
      </Modal>
    </>
  );
};
